import { getFirstItemHrefInSection } from '../../utils';
import { toUrlFormat } from '../../../../../utils/treeVisitors';

export const focusFirstItemArticle = (store, itemIndex) => {
  setTimeout(() => {
    store.publishToFocusLocation(
      getFirstItemHrefInSection('markdown', itemIndex),
    );
  }, 200);
};

export const getUrlFormatTitle = (title) => `/${toUrlFormat(title)}`;

export const getFirstArticlePath = (items, i) =>
  toUrlFormat(`/${items[i].title}#${items[i].articles[0].name}`);

export const getTitleIndex = (items, title) => {
  return items.findIndex(
    (item) => toUrlFormat(item.title.toLowerCase()) === title.replace('/', ''),
  );
};
